var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewLocation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.75V6.25C9.5 6.38807 9.38807 6.5 9.25 6.5H6.5V9.25C6.5 9.38807 6.38807 9.5 6.25 9.5H5.75C5.61193 9.5 5.5 9.38807 5.5 9.25V6.5H2.75C2.61193 6.5 2.5 6.38807 2.5 6.25V5.75C2.5 5.61193 2.61193 5.5 2.75 5.5H5.5V2.75C5.5 2.61193 5.61193 2.5 5.75 2.5H6.25C6.38807 2.5 6.5 2.61193 6.5 2.75V5.5H9.25C9.38807 5.5 9.5 5.61193 9.5 5.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18C12 13.5817 15.5817 10 20 10C24.4183 10 28 13.5817 28 18C28 21.7564 26.1763 23.226 24.4762 24.596C23.3613 25.4945 22.2994 26.3502 21.84 27.78L21.33 29.32C21.187 29.7454 20.7782 30.0234 20.33 30H19.77C19.3218 30.0234 18.913 29.7454 18.77 29.32L18.26 27.78C17.7822 26.3544 16.7055 25.4996 15.5774 24.604C13.849 23.2317 12 21.7637 12 18ZM17 18C17 19.6569 18.3431 21 20 21C20.7956 21 21.5587 20.6839 22.1213 20.1213C22.6839 19.5587 23 18.7956 23 18C23 16.3431 21.6569 15 20 15C18.3431 15 17 16.3431 17 18Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewLocation.f89c17ae.svg";
export { ForwardRef as ReactComponent };